function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "eN");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "App-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "eN",
  fill: "#BFBBB7"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.2,9.405 L3.78,9.405 C3.78,9.695 3.778,9.93 3.772,10.11 C3.768,10.29 3.747,10.4 3.712,10.44 C3.677,10.48 3.62,10.5 3.54,10.5 L0,10.5 L0,0.24 C0,0.2 0.015,0.15 0.045,0.09 C0.075,0.03 0.14,0 0.24,0 L3.84,0 C3.84,0.28 3.838,0.51 3.832,0.69 C3.828,0.87 3.81,0.982 3.78,1.028 C3.75,1.073 3.695,1.095 3.615,1.095 L1.2,1.095 L1.2,4.23 L3.465,4.23 C3.465,4.5 3.463,4.725 3.457,4.905 C3.453,5.085 3.435,5.202 3.405,5.257 C3.375,5.313 3.32,5.34 3.24,5.34 L1.2,5.34 L1.2,9.405 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.75828552,0.000510579214 C10,0.000510579214 10,0.0685577393 10,0.353729248 L10,10.0691681 C10,10.283371 10,10.3628961 9.81855774,10.3628961 L9.17478238,10.3628961 L6.10426687,2.88833718 L6.07281477,10.4656337 L5.2177124,10.4656337 C4.94665918,10.4656337 5,10.3100227 5,10.1096344 L5,0.353729248 C5,0.125060986 5.01277491,0.0127021661 5.27794616,-2.23192558e-13 C5.37385888,-0.00459438725 5.59669308,-0.00442419417 5.94644874,0.000510579214 L8.89474924,7.04495127 L8.89474924,0.000510579214 L9.75828552,0.000510579214 Z",
  id: "Path-18",
  fillRule: "nonzero"
})));

var SvgEn = function SvgEn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "11px",
    viewBox: "0 0 10 11",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en.f9d39c6d.svg";
export { ForwardRef as ReactComponent };